var ajaxPromise,
	pathArray = location.href.split('/'),
	protocol = pathArray[0],
	host = pathArray[2],
	ajax_url = protocol + '//' + host + '/wp-admin/admin-ajax.php';

function teamFilter(term_id) {
    $('#team-results').empty();

    $('#loading').addClass('active');
    $('#load-more').addClass('hide');
    $('#load-more').attr('data-term', term_id);
    $('#load-more').attr('data-page', 1);

    var result, total;
    ajaxPromise = $.ajax({
        type: 'POST',
        url: ajax_url,
        dataType: 'json',
        data: ({
            'action': 'ajax_team_filter',
            'term_id': term_id,
        }),
        success: function (data) {
            result = data.html;  
            total = data.total;
        }
    });
    $.when(ajaxPromise).done(function () {
        $('#team-results').html(result);
        $('#team-results').attr('data-total', total);
        $('#loading').removeClass('active');
        reviewLoadmore();
    });
} 

function reviewLoadmore(){
    var total = $('#team-results').attr('data-total');
    var numitems = $('#team-results .c__tease--team-member').length; 
  
    if(total > numitems){
      $('#load-more').removeClass('hide'); 
    } else {
      $('#load-more').addClass('hide'); 
    }
}

$(document).on("click", 'body.page-template-page-team .c__filter__links li[data-id]', function(e) { 
    e.preventDefault(); 

    $('.c__filter__links li').removeClass('active');
    $(this).addClass('active');

    var term_id = $(this).attr('data-id');
    teamFilter(term_id);
});

$(document).on("change", 'body.page-template-page-team select[name="team-filter"]', function(e) { 
    e.preventDefault(); 
    var term_id = $(this).val();
    teamFilter(term_id);
});

$(document).on("click", 'body.page-template-page-team #load-more, body.page-template-page-team-exec-board #load-more, body.page-template-page-team-operations-manager #load-more, body.page-template-page-team-board-of-directors #load-more', function() { 
    var page_num =  parseInt($('#load-more').attr('data-page'));
    page_num++;
    var term_id = $(this).attr('data-term');

    $('#loading').addClass('active');
    $('#load-more').addClass('hide'); 

    var animPromise, result;
    ajaxPromise = $.ajax({
        type: 'POST',
        url: ajax_url,
        dataType: 'json',
        data: ({
            'action': 'ajax_team_filter',
            'term_id': term_id,
            'paged': page_num 
        }),
        success: function (data) {
            result = data.html; 
        }
    });
    $.when(animPromise, ajaxPromise).done(function () {
        $('#team-results').append(result);
        $('#loading').removeClass('active'); 
        $('#load-more').attr('data-page', page_num);
        reviewLoadmore();
    });
});